/* eslint formatjs/no-literal-string-in-jsx: "error" */

import React, { useState } from "react"
import { Badge, FlexContainer, Icon, Stack, TextLink } from "@carrotfertility/carotene"
import { NETWORK_ID_TIER_MAPPING } from "../../utils/networkIdMapping"
import { ProviderTypeTags } from "./ProviderTypeTags"
import { tierForModalProps, TierInfoModal } from "./TierInfoModal"
import { FormattedMessage } from "react-intl"
import { Benefit } from "pages/provider-finder/types/Benefit"

export function ProviderTypeTagsForExtendedNetworks({
  parentIds,
  providerTypeIds,
  networkIds,
  benefit
}: {
  parentIds: number[]
  providerTypeIds: number[]
  networkIds: number[]
  benefit: Benefit
}): JSX.Element {
  const [open, setOpen] = useState(false)
  const [tierForModal, setTierForModal] = useState<tierForModalProps>(null)

  const providerTierTags = networkIds.map((networkId, i) => {
    const providerTier = NETWORK_ID_TIER_MAPPING[networkId]

    if (providerTier) {
      return (
        <TextLink
          key={i}
          onClick={() => {
            setOpen(true)
            setTierForModal(providerTier)
          }}
        >
          <Badge size="medium" backgroundColor={providerTier.backgroundColor} color={providerTier.color} key={i}>
            <FlexContainer alignItems="center">
              <FormattedMessage {...providerTier.tierDisplayName} />
              &nbsp;
              <Icon name="helpCircle" color={providerTier.iconColor} sx={{ height: "14px" }} />
            </FlexContainer>
          </Badge>
        </TextLink>
      )
    }
    return <></>
  })

  return (
    <FlexContainer direction="row" gap="8px">
      <ProviderTypeTags parentIds={parentIds} providerTypeIds={providerTypeIds} benefit={benefit} />
      <Stack direction="row" spacing="0" gap="8px 4px" sx={{ marginBottom: "12px" }}>
        {providerTierTags}
      </Stack>
      <TierInfoModal open={open} onClose={() => setOpen(false)} tierForModal={tierForModal} benefit={benefit} />
    </FlexContainer>
  )
}
